import { useAuth } from "@/context/AuthContext";

// V3 page head: breadcrumb (desktop) or own name and role (mobile), large title, subtitle, actions on the right.
export function PageHeader({ title, subtitle, actions, crumb }) {
  const { user } = useAuth();
  return (
    <div className="mb-6 animate-fade-in-up">
      <p className="hidden text-base font-semibold text-zinc-600 lg:block" data-testid="page-crumb">{crumb || title} / Plattformverwaltung</p>
      <p className="text-base font-semibold text-zinc-600 lg:hidden">{user?.name} · {user?.role_label}</p>
      <div className="mt-3 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <h1 lang="de" className="break-words text-3xl font-bold leading-tight tracking-tight text-brand-purple hyphens-auto lg:text-[2.15rem]">{title}</h1>
          {subtitle && <p className="mt-2 max-w-prose text-lg leading-relaxed text-zinc-600">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
